module.exports = __webpack_public_path__ + "img/9791187886068.027d833f.jpg";